module.exports = __webpack_public_path__ + "static/media/001-sad.7b49a330.svg";